module.exports = __webpack_public_path__ + "static/media/bw.d1585fdf.svg";